import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const authExpiredInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error) => {
      if (shouldRedirectToLogin(req.url, error)) {
        if (typeof window !== 'undefined') {
          const loginUrl = new URL('/login', window.location.origin);
          loginUrl.searchParams.set('returnUrl', currentReturnPath());
          window.location.href = loginUrl.toString();
        }
      }
      return throwError(() => error);
    }),
  );
};

function shouldRedirectToLogin(url: string, error: unknown): boolean {
  return typeof window !== 'undefined'
    && error instanceof HttpErrorResponse
    && (error.status === 401 || error.status === 419)
    && !isLoginPage()
    && !isBypassedAuthEndpoint(url);
}

function currentReturnPath(): string {
  if (typeof window === 'undefined') return '/dashboard';
  return safeReturnPath(`${window.location.pathname}${window.location.search}${window.location.hash}`);
}

function isLoginPage(): boolean {
  const path = window.location.pathname;
  return path === '/login' || path.startsWith('/login/');
}

function isBypassedAuthEndpoint(url: string): boolean {
  return (
    url.includes('/api/v1/user/auth-verify') ||
    url.includes('/api/v1/user/login') ||
    url.includes('/api/v1/user/pre-authenticate') ||
    url.includes('/api/v1/user/verify') ||
    url.includes('/api/v1/user/send-token') ||
    url.includes('/api/v1/user/mfa/delivery-capabilities') ||
    url.includes('/api/v1/user/refresh') ||
    url.includes('/api/v1/user/logout')
  );
}

function safeReturnPath(value: string | null | undefined): string {
  if (!value || value.startsWith('http://') || value.startsWith('https://') || value.startsWith('//')) return '/dashboard';
  const path = value.startsWith('/') ? value : `/${value}`;
  return path === '/login' || path.startsWith('/login?') || path.startsWith('/login/') ? '/dashboard' : path;
}
